// Payment API for subscription management
import api from './authApi';

const SUBSCRIPTION_API_BASE = '/profile';

export const subscriptionApi = {
  // Get current user plan
  getCurrentPlan: async (userId) => {
    try {
      const response = await api.get(`${SUBSCRIPTION_API_BASE}/current-plan/${userId}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch current plan'
      };
    }
  },

  // Get plan prices
  getPlanPrices: async () => {
    try {
      const response = await api.get(`${SUBSCRIPTION_API_BASE}/plan-prices`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch plan prices'
      };
    }
  },

  // Create payment order for Razorpay
  createPaymentOrder: async (userId, planType, amount) => {
    try {
      const response = await api.post(`${SUBSCRIPTION_API_BASE}/create-payment-order`, {
        userId,
        planType,
        amount
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to create payment order'
      };
    }
  },

  // Simulate payment processing
  simulatePayment: async (planType, amount) => {
    try {
      const response = await api.post(`${SUBSCRIPTION_API_BASE}/simulate-payment`, {
        planType,
        amount
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Payment processing failed'
      };
    }
  },

  // Upgrade user plan
  upgradePlan: async (userId, upgradeData) => {
    try {
      const response = await api.post(`${SUBSCRIPTION_API_BASE}/upgrade-plan/${userId}`, upgradeData);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Plan upgrade failed'
      };
    }
  },

  // Process complete payment flow
  processPayment: async (userId, planType, amount) => {
    try {
      // Step 1: Simulate payment processing
      const paymentResult = await subscriptionApi.simulatePayment(planType, amount);
      
      if (!paymentResult.success) {
        throw new Error(paymentResult.error);
      }

      // Step 2: Create upgrade request
      const upgradeData = {
        planType: planType.toUpperCase(),
        paymentMethod: 'UPI', // Default to UPI
        transactionId: paymentResult.data.transactionId,
        amount: amount,
        currency: 'INR'
      };

      // Step 3: Upgrade plan
      const upgradeResult = await subscriptionApi.upgradePlan(userId, upgradeData);
      
      return upgradeResult;
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Payment processing failed'
      };
    }
  }
};

export default subscriptionApi;
